/**
 * @generated SignedSource<<3ebb4d5221e6dfb51a672a07f6812ef8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PrePaymentRequirement = "COLLECT_CARD_ON_FILE" | "FULL" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type EventSignupSummaryContent_event$data = {
  readonly eventSeries: {
    readonly facility: {
      readonly club: {
        readonly supportsPublic: boolean;
      } | null | undefined;
      readonly isEventPrePaymentEnabled: boolean;
    };
    readonly name: string;
  };
  readonly id: string;
  readonly prePaymentRequirement: PrePaymentRequirement | null | undefined;
  readonly unknownGuestsAllowed: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"EventSignupSummaryActions_event" | "EventSignupSummaryHeader_event" | "EventSignupSummaryPlayerList_event" | "UpdateAttendeesGroupEventsModal_event" | "useInitEventForm_formQuestionConfiguration" | "useInitEventMeta_event" | "useInitEventSignUps_event" | "useInitGroupEvent_event">;
  readonly " $fragmentType": "EventSignupSummaryContent_event";
};
export type EventSignupSummaryContent_event$key = {
  readonly " $data"?: EventSignupSummaryContent_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSignupSummaryContent_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSignupSummaryContent_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unknownGuestsAllowed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prePaymentRequirement",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isEventPrePaymentEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "supportsPublic",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventSignupSummaryHeader_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventSignupSummaryPlayerList_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventSignupSummaryActions_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useInitGroupEvent_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useInitEventMeta_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useInitEventForm_formQuestionConfiguration"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useInitEventSignUps_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdateAttendeesGroupEventsModal_event"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "487646d415cbe9a11e049f53dc2814ef";

export default node;
